"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailLink = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Link_1 = require("./Link");

var EmailLink = function EmailLink(_a) {
  var to = _a.to,
      children = _a.children,
      _a$autoResize = _a.autoResize,
      autoResize = _a$autoResize === void 0 ? true : _a$autoResize,
      props = __rest(_a, ["to", "children", "autoResize"]);

  return (0, jsx_runtime_1.jsx)(Link_1.Link, Object.assign({
    gatsby: false,
    autoResize: autoResize,
    to: "mailto:".concat(to)
  }, props, {
    children: children || to
  }));
};

exports.EmailLink = EmailLink;